import { httpClient } from "../../../../services/httpClient";

export const fetchSecretariaDashboard = () => httpClient.get("/api/dashboard/secretaria");

const secretariaDashboardService = {
  fetch: fetchSecretariaDashboard,
};

export default secretariaDashboardService;
